import React from "react";
import { bigLogo } from "../../Assets";

const PleaseWait = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="not-found-menu please-wait-page">
            <figure>
              <img src={bigLogo} />
            </figure>
            <h1>Please Wait!</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PleaseWait;
